import { trustPoints } from '@/mocks/home';

export default function TrustPoints() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="w-full">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="font-heading text-sm tracking-widest text-primary-600">为什么在这里投稿</span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
              我们先把投稿人的顾虑解决掉
            </h2>
          </div>
          <p className="text-sm md:text-base leading-7 text-foreground-600 max-w-md">
            投稿最难的一步从来不是「有没有料」，而是「说了会不会被认出来」。
            所以在设计投稿入口之前，我们先确定了对投稿人的四条承诺。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {trustPoints.map((p) => (
            <article
              key={p.title}
              className="flex flex-col p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className={`${p.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-5 text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600">{p.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}